import { AppBrandingService } from './app-branding.service';

export const appBrandingInitializerFactory = (brandingService: AppBrandingService) => () => brandingService.branding$;
